import { useMutation, useQuery, useQueryClient } from 'react-query'
import { CapacityTypes, AutoBowWaveTypes } from './Capacity.types'
import { request } from 'Features/auth/axios-client'
import { format } from 'date-fns'
import { WorkcentreCapacityParams } from 'Features/EditCapacity/EditCapacity.types'
import { WORKCENTRE_STATUS_FETCH_TIMEOUT } from 'Common/Constants/Constants'

const fetchCapacityTable = async ({
  sourcesiteId,
  planId,
  workcentreId,
  selectedDate,
}: CapacityTypes) => {
  const data = await request({
    url: `plan/${planId}/source-sites/${sourcesiteId}/workcentres/${workcentreId}/capacity-table?date=${selectedDate}`,
  })
  return data
}

export const useCapacityTable = (params: CapacityTypes) => {
  return useQuery(
    [
      'capacity-table',
      params.planId,
      params.selectedDate,
      params.workcentreId,
      params.sourcesiteId,
    ],
    () => fetchCapacityTable(params),
    {
      refetchOnMount: false,
      select: (data) => data?.data?.data,
      enabled: params.selectedDate !== null,
      cacheTime: 0,
    }
  )
}

const fetchCapacityData = async ({
  sourcesiteId,
  planId,
  workcentreId,
}: CapacityTypes) => {
  const { data } = await request({
    url: `plan/${planId}/source-sites/${sourcesiteId}/workcentres/${workcentreId}/capacity/download`,
  })

  console.log('Capacity Download')
  console.log(data)

  const fileName = `capacity_data__${format(new Date(), 'yyyyMMdd')}`
  const url = window.URL.createObjectURL(new Blob([data]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', `${fileName}.csv`)
  document.body.appendChild(link)
  link.click()
  return data
}

export const useDownloadCapacity = (params: CapacityTypes) => {
  return useQuery(
    [
      'capacity-data-download',
      params.planId,
      params.sourcesiteId,
      params.workcentreId,
    ],
    () => fetchCapacityData(params),
    {
      refetchOnMount: false,
      select: (data) => data?.data,
      enabled: false,
      cacheTime: 0,
    }
  )
}

const fetchAutoBowWave = async ({
  planId,
  workcentreId,
  sourcesiteId,
}: AutoBowWaveTypes) => {
  const { data } = await request({
    method: 'put',
    data: {},
    url: `plan/${planId}/source-sites/${sourcesiteId}/workcentres/${workcentreId}/auto_bow_wave`,
  })
  return data
}

export const useAutoBowWave = (
  onSuccess: () => void,
  onError: (error: unknown) => void
) => {
  return useMutation(fetchAutoBowWave, {
    onSuccess: () => {
      onSuccess()
    },
    onError: (error) => {
      onError(error)
    },
  })
}

const fetchCapacityWorkcentreRunStatus = async (
  params: WorkcentreCapacityParams
) => {
  const { planId, sourcesiteId, workcentreId } = params
  const data = await request({
    url: `plan/${planId}/source-sites/${sourcesiteId}/workcentres/${workcentreId}/run-status`,
  })
  return data
}

export const useCapacityWorkcentreRunStatus = (
  params: WorkcentreCapacityParams
) => {
  return useQuery(
    [
      'workcentre-run-status',
      params.planId,
      params.sourcesiteId,
      params.workcentreId,
    ],
    () => fetchCapacityWorkcentreRunStatus(params),
    {
      cacheTime: 0,
      select: (response) => response?.data?.data,
      refetchOnWindowFocus: false,
      refetchInterval: WORKCENTRE_STATUS_FETCH_TIMEOUT,
    }
  )
}
